"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "clearWarningsCache", {
  enumerable: true,
  get: function () {
    return _warning.clearWarningsCache;
  }
});
Object.defineProperty(exports, "warnOnce", {
  enumerable: true,
  get: function () {
    return _warning.warnOnce;
  }
});
var _warning = require("./warning");